export const en = {
  dashboardLoadMessage: 'Dashboard Might take 3-4 seconds to load',
};

export const ar: typeof en = {
  dashboardLoadMessage: 'قد يستغرق تحميل الصفحة ٥ ثوان',
};
